var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.computedRows > 0)?_c('div',{staticClass:"overflow-auto"},[_c('b-pagination',{attrs:{"total-rows":_vm.computedRows,"per-page":_vm.perPage,"first-number":""},on:{"input":_vm.updateQuery},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }